import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        let addDataScroll = ['.wp-block-media-text__media', '.wp-block-media-text__content', '.wp-block-heading', '.c-process__block', '.wp-block-group', '.wp-block-buttons', '.c-cta__block', '.o-title-1.-text-center', '.o-form__wrap','.wp-block-media-text__content p'];
        let addDataScrollAnimClass =    ['u-anim-media-text__media', 'u-anim-media-text__content', 'u-anim-block-heading', 'u-anim-process__block', 'u-anim-block-group', 'u-anim-block-buttons','u-anim-cta__block','u-anim-title','u-anim-form','u-anim-opacity-up'];

        // loop dom elements for these classes and add data-scroll and add animation class
        addDataScroll.forEach((el, index) => {
            let elements = document.querySelectorAll('.o-gutenberg '+ el);
            elements.forEach((element) => {
                element.setAttribute('data-scroll', '');
                element.classList.add(addDataScrollAnimClass[index]);
            });
        });

        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
            scrollCallback: this.onScroll,
        });

        window.locomotiveScroll.scrollTo(0, {
            duration: 0,
            lerp: 0,
        });

        // data-scroll-event-progress Example
        window.addEventListener('progressEvent', (e) => {
            const { target, progress } = e.detail;
            const percent = progress * 100;
            const percentRounded = Math.round(progress * 100);
            const progressEl = document.querySelector('.js-progress');
            const progressBarEl = document.querySelector('.js-progress-bar');

            if (progress && progressEl && progressBarEl) {
                progressEl.innerHTML = percentRounded + '%';
                progressBarEl.style.cssText += `width: ${percent}%;`;
            }
        });
    }

    onScroll({ direction, scroll }) {
        if (scroll < 50) {
            document.querySelector('html').classList.remove('lenis-scrolling-up');
            document.querySelector('html').classList.remove('lenis-scrolling-down');
        } else if (direction === -1) {
            document.querySelector('html').classList.add('lenis-scrolling-up');
            document.querySelector('html').classList.remove('lenis-scrolling-down');
        } else if (direction === 1) {
            document.querySelector('html').classList.remove('lenis-scrolling-up');
            document.querySelector('html').classList.add('lenis-scrolling-down');
        } else {
            document.querySelector('html').classList.remove('lenis-scrolling-up');
            document.querySelector('html').classList.add('lenis-scrolling-down');
        }
    }

    destroy() {
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
        window.removeEventListener('progressEvent', () => { });
    }
}
